// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"538":"recorder","983":"profiler"}[chunkId] + "-legacy." + {"538":"0c860f15","983":"46019d5c"}[chunkId] + ".js";
};